// extracted by mini-css-extract-plugin
module.exports = {"container":"UserList_container__X8P2n","item":"UserList_item__2lVOm","text":"UserList_text__pFTcb"};